import _toConsumableArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// ignore-string-externalization
import React from 'react';
import qs from 'query-string';
import memoize from 'lodash/memoize';
import uniqBy from 'lodash/uniqBy';
import * as contentful from 'contentful';
var PAGE_SIZE = 10;

var getPreviewAPI = function getPreviewAPI() {
  return contentful.createClient({
    host: process.env.REACT_APP_CONTENTFUL_PREVIEW_HOST,
    environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
    space: process.env.REACT_APP_CONTENTFUL_SPACE || '',
    accessToken: process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN,
    resolveLinks: true,
    retryOnError: false
  });
};

var getAPI = memoize(function () {
  return contentful.createClient({
    host: process.env.REACT_APP_CONTENTFUL_HOST,
    environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
    space: process.env.REACT_APP_CONTENTFUL_SPACE || '',
    accessToken: process.env.REACT_APP_CONTENTFUL_TOKEN,
    resolveLinks: true,
    retryOnError: false
  });
});
var getSearchAPI = memoize(function () {
  return contentful.createClient({
    host: process.env.REACT_APP_CONTENTFUL_HOST,
    environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
    space: process.env.REACT_APP_CONTENTFUL_SPACE || '',
    accessToken: process.env.REACT_APP_CONTENTFUL_TOKEN,
    resolveLinks: false,
    retryOnError: true,
    timeout: 10000
  });
});
export function fetchEntry(_x) {
  return _fetchEntry.apply(this, arguments);
}

function _fetchEntry() {
  _fetchEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(props) {
    var data, entries;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchEntryList(_objectSpread(_objectSpread({}, props), {}, {
              limit: 1,
              skip: 0
            }));

          case 2:
            data = _context2.sent;
            entries = data.entries;

            if (!(!entries || !entries.length)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", null);

          case 8:
            if (entries.length > 1) {
              // eslint-disable-next-line no-console
              console.error("".concat(entries.length, " items returned for ").concat(props.contentType, " query"));
            }

          case 9:
            return _context2.abrupt("return", entries[0]);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchEntry.apply(this, arguments);
}

export function fetchEntryList(_x2) {
  return _fetchEntryList.apply(this, arguments);
}

function _fetchEntryList() {
  _fetchEntryList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
    var contentType, order, _ref$filters, filters, _ref$limit, limit, _ref$skip, skip, _ref$filterNulls, filterNulls, select, query, locale, _ref$preview, preview, linksToEntry, params, _i2, _Object$entries2, _Object$entries2$_i, _key3, val;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            contentType = _ref.contentType, order = _ref.order, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$skip = _ref.skip, skip = _ref$skip === void 0 ? 0 : _ref$skip, _ref$filterNulls = _ref.filterNulls, filterNulls = _ref$filterNulls === void 0 ? true : _ref$filterNulls, select = _ref.select, query = _ref.query, locale = _ref.locale, _ref$preview = _ref.preview, preview = _ref$preview === void 0 ? false : _ref$preview, linksToEntry = _ref.linksToEntry;
            params = {
              limit: limit,
              skip: skip,
              order: order,
              select: select,
              query: query,
              locale: locale,
              links_to_entry: linksToEntry
            };

            for (_i2 = 0, _Object$entries2 = Object.entries(filters); _i2 < _Object$entries2.length; _i2++) {
              _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), _key3 = _Object$entries2$_i[0], val = _Object$entries2$_i[1];

              if (val !== null) {
                if (_key3.startsWith('sys')) {
                  params[_key3] = val;
                } else {
                  params["fields.".concat(_key3)] = val;
                }
              }
            }

            return _context3.abrupt("return", apiFetchEntries(contentType, params, filterNulls, preview));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchEntryList.apply(this, arguments);
}

function apiFetchEntries() {
  return _apiFetchEntries.apply(this, arguments);
}

function _apiFetchEntries() {
  _apiFetchEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var contentType,
        params,
        filterNulls,
        preview,
        fetchParams,
        api,
        entries,
        circularJsonSafeEntries,
        parsedEntires,
        items,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            contentType = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
            params = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            filterNulls = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
            preview = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : false;
            fetchParams = _objectSpread({
              include: 3
            }, params);

            if (contentType) {
              if (Array.isArray(contentType)) {
                fetchParams['sys.contentType.sys.id[in]'] = contentType.join(',');
              } else {
                fetchParams.content_type = contentType;
              }
            }

            if (!preview) {
              _context4.next = 12;
              break;
            }

            _context4.next = 9;
            return getPreviewAPI();

          case 9:
            api = _context4.sent;
            _context4.next = 21;
            break;

          case 12:
            if (!params.query) {
              _context4.next = 18;
              break;
            }

            _context4.next = 15;
            return getSearchAPI();

          case 15:
            api = _context4.sent;
            _context4.next = 21;
            break;

          case 18:
            _context4.next = 20;
            return getAPI();

          case 20:
            api = _context4.sent;

          case 21:
            _context4.next = 23;
            return api.getEntries(fetchParams);

          case 23:
            entries = _context4.sent;

            if (filterNulls) {
              entries.items = entries.items.filter(function (e) {
                return e !== null && Boolean(e.sys.contentType);
              });
            }

            circularJsonSafeEntries = entries.stringifySafe();
            parsedEntires = JSON.parse(circularJsonSafeEntries);
            items = parsedEntires.items.map(function (entry) {
              var _entry$sys$contentTyp;

              return expand(entry.sys.id, ((_entry$sys$contentTyp = entry.sys.contentType) === null || _entry$sys$contentTyp === void 0 ? void 0 : _entry$sys$contentTyp.sys.id) || '', entry.fields);
            });
            return _context4.abrupt("return", {
              limit: entries.limit,
              skip: entries.skip,
              total: entries.total,
              entries: items,
              totalUnfiltered: entries.total
            });

          case 29:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _apiFetchEntries.apply(this, arguments);
}

var isContentful = function isContentful(type, v) {
  var _v$sys;

  return (v === null || v === void 0 ? void 0 : (_v$sys = v.sys) === null || _v$sys === void 0 ? void 0 : _v$sys.type) === type;
};
/*
 * Formats a Contentful Entry of the form:
 *  {
 *    sys: { id: 'abc', contentType: { sys: { id: '123' } }, ... }
 *    fields: { some: 'value',  nested: { sys: { ... }, fields: { ... } }
 *  }
 * to a flatter structure with linked Entries/Assets also formatted
 *  {
 *    id: 'abc',
 *    contentType: '123',
 *    some: 'value',
 *    nested: { id: ..., contentType: ..., ... }
 *  }
 *
 * Assumptions:
 *  - the contentful client has been configured with `resolveLinks: true`
 *    - this ensures that valid linked Entries are resolved to their values
 *  - the entry has been fetched with `#getEntries` and processed with `#stringifySafe`
 *    - this ensures that circular entries are shown as Links rather than being resolved, avoiding infinite loops
 */


export function expand(id, ctype, fields) {
  if (!fields) {
    return fields;
  }

  fields.id = id;
  fields.contentType = ctype;

  var _iterator = _createForOfIteratorHelper(Object.entries(fields)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          _key2 = _step$value[0],
          _val = _step$value[1];

      if (_val === null || _val === undefined) {
        continue;
      } else if (Array.isArray(_val)) {
        fields[_key2] = _val.map(function (v) {
          var _v$sys2, _v$sys2$contentType;

          return typeof v === 'object' && v.sys && v.fields && (_v$sys2 = v.sys) !== null && _v$sys2 !== void 0 && (_v$sys2$contentType = _v$sys2.contentType) !== null && _v$sys2$contentType !== void 0 && _v$sys2$contentType.sys ? expand(v.sys.id, v.sys.contentType.sys.id, v.fields) : v;
        });
      } else if (isContentful('Entry', _val)) {
        fields[_key2] = expand(_val.sys.id, _val.sys.contentType.sys.id, _val.fields);
      } else if (isContentful('Asset', _val)) {
        var asset = _val.fields;
        fields[_key2] = asset;
      }
    } // make arrays of objects for field keys of the form:
    // foo__1__bar, foo__1__baz, foo__2__bar, foo__2__baz, etc.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _i = 0, _Object$entries = Object.entries(fields); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _key = _Object$entries$_i[0],
        val = _Object$entries$_i[1];

    var _key$split = _key.split('__'),
        _key$split2 = _slicedToArray(_key$split, 3),
        arrKey = _key$split2[0],
        indexKey = _key$split2[1],
        propKey = _key$split2[2];

    if (arrKey && indexKey && propKey) {
      var i = parseInt(indexKey, 10) - 1;
      var arr = fields[arrKey] || [];
      arr[i] = arr[i] || {};
      arr[i][propKey] = val;
      fields[arrKey] = arr;
      delete fields[_key];
    }
  }

  return fields;
}
export function makeWebpUrl(imgUrl) {
  var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;

  var _qs$parseUrl = qs.parseUrl(imgUrl),
      url = _qs$parseUrl.url,
      query = _qs$parseUrl.query;

  delete query.fl;
  query.fm = 'webp';
  query.q = "".concat(quality);
  return "".concat(url, "?").concat(qs.stringify(query));
}
export function makeJpgUrl(imgUrl, fl, quality) {
  var _qs$parseUrl2 = qs.parseUrl(imgUrl),
      url = _qs$parseUrl2.url,
      query = _qs$parseUrl2.query;

  query.fm = 'jpg';
  if (fl) query.fl = "".concat(fl);
  if (quality) query.q = "".concat(quality);
  return "".concat(url, "?").concat(qs.stringify(query));
}
export function makeImageSizeUrl(imgUrl, width, height, fit, focus) {
  var _qs$parseUrl3 = qs.parseUrl(imgUrl),
      url = _qs$parseUrl3.url,
      query = _qs$parseUrl3.query;

  if (width !== undefined && !isNaN(width)) query.w = "".concat(width);
  if (height !== undefined && !isNaN(height)) query.h = "".concat(height);
  if (fit) query.fit = "".concat(fit);
  if (focus) query.f = "".concat(focus);
  return "".concat(url, "?").concat(qs.stringify(query));
}
export function makeContentfulAsset(_ref2) {
  var url = _ref2.url,
      contentType = _ref2.contentType,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? -1 : _ref2$size,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? '' : _ref2$description;
  return {
    file: {
      contentType: contentType,
      url: url,
      details: {
        size: size,
        image: {
          width: width,
          height: height
        }
      }
    },
    description: description,
    contentType: contentType
  };
}
export function usePagedEntryList(query) {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      entries = _React$useState2[0],
      setEntries = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      pageNum = _React$useState4[0],
      setPageNum = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var page = React.useRef(null);
  var pageSize = query.limit || PAGE_SIZE;

  var hasNextPage = function hasNextPage() {
    return !page.current && true || pageNum * pageSize < page.current.total;
  };

  var getNextPage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var nextPageNum, q;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (hasNextPage) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              nextPageNum = pageNum + 1;
              q = _objectSpread(_objectSpread({}, query), {}, {
                skip: (nextPageNum - 1) * pageSize
              });
              setLoading(true);
              fetchEntryList(q).then(function (data) {
                var newEntries = [].concat(_toConsumableArray(entries || []), _toConsumableArray(data.entries)).filter(Boolean);
                page.current = data;
                setEntries(uniqBy(newEntries, 'id'));
                setPageNum(nextPageNum);
                setLoading(false);
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getNextPage() {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    getNextPage();
  }, [pageNum]);
  return {
    entries: entries,
    page: page,
    pageNum: pageNum,
    pageSize: pageSize,
    loading: loading,
    hasNextPage: hasNextPage,
    getNextPage: getNextPage
  };
}